<div class="message-reply" (click)="onClickMessage(messageId)">
  <p class="message-reply__sender">
    {{ message?.senderId | senderFullName | async }}
  </p>

  <div class="message-reply__content">
    <span class="message-reply__text">
      {{ message | messageNote | async }}
    </span>
  </div>
</div>
